exports.list = {
    path: '/laporan_permintaan_teknisi',
    name: 'laporan_permintaan_teknisi_list', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/laporan_permintaan_teknisi/List.vue"),
}